<template>
    <div :class="{'with-file': isFilled}">
        <v-row v-if="isFilled" class="file-uploaded-name">
            <v-col>
                <TextLengthLimitations  :text="showName" chars="25"></TextLengthLimitations>
            </v-col>
        </v-row>
        <v-row class="dropbox">
            <v-col>
                <input
                        type="file"
                        ref="fileUpload"
                        class="input-file"
                        @change="filesChange($event.target); fileCount = $event.target.files.length"
                        accept=".pdf,image/*,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                >
                <responsive-button style="min-width: 71%"
                        :setDisabled="isDisabled"
                        :setClick="this.fileUploadAction"
                        setColor="success"
                        setDefaultIcon="cloud_upload"
                        setSmallIcon="cloud_upload"
                        :setCircular="iconMode"
                >
                    Upload
                </responsive-button>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    const TextLengthLimitations = ()=> import("@/components/common/TextLengthLimitations");
    const responsiveButton = () => import ('@/components/common/mobile/Button');

    const uuidv4 = require('uuid/v4');
    const STATUS_EMPTY = 0, STATUS_FILLED = 1;

    export default {
        name: "FileUpload",
        props:['created_by', 'belong','display_name', 'document_type', 'reviewer_cognito_username', 'entity_type', 'setIcon', 'setDisabled','document_rule'],
        components: {TextLengthLimitations, responsiveButton},
        data(){
            return{
                currentStatus: null,
                showName: ''
            };
        },
        computed: {
            isEmpty() {
                return this.currentStatus === STATUS_EMPTY;
            },
            isFilled(){
                return this.currentStatus === STATUS_FILLED;
            },
            iconMode (){
                return this.setIcon || false;
            },
            isDisabled(){
                return this.setDisabled || false;
            }
        },
        methods:{
            reset() {
                // reset form to initial state
                this.currentStatus = STATUS_EMPTY;
            },
            async filesChange(target){
                let file = target.files[0];
                if(!!!file){
                    //skip not file selected
                    return;
                }

                let name = this.fileName ? this.fileName+'.'+file.name.split('.').pop() : file.name;
                let metadata = {
                    uploader_cognito_sub: this.getUploader().attributes.sub,
                    uploader_cognito_username: this.getUploader().username,
                    created_by: this.created_by,
                    belong: this.belong,
                    display_name: this.display_name,
                    document_type: this.document_type,
                    reviewer_cognito_username: this.getUploader().username, //this is temporal
                    entity_type: this.entity_type,
                    name: name.split(' ').join('_'),
                    file_id: uuidv4(),
                    document_rule: this.document_rule
                };

                this.currentStatus = STATUS_FILLED;
                this.showName = file.name;
                this.$emit('file-uploaded',{file: file, metadata: metadata});
            },
            async fileUploadAction (){
                this.$refs.fileUpload.click();
            },
            getUploader(){
                return this.$store.getters.getUser;
            },
        },
        mounted() {
            this.reset();
        }
    }
</script>

<style scoped>
    .dropbox {
        outline-offset: -10px;
        padding: 10px 10px;
        min-height: 10%; /* minimum height */
        position: relative;
        cursor: pointer;
        max-height: 110px;
    }

    .dropbox.with-file{
        padding: 0px 10px;
    }

    .input-file {
        opacity: 0; /* invisible but it's there! */
        width: 100%;
        height: 100%;
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 0;
    }

    .file-uploaded-name{
        min-height: 25px;
    }
</style>